import React, {Component} from 'react';
import {Form, message, Table} from 'antd';
import {Link} from 'react-router';
import moment from 'moment';
import util from '@util/index';
import {queryInvoiceDelete} from '@api/incubator/invoice';
import {queryInvoiceType} from '@api/core/dict';
import LocalDb from '@util/localDb';

class Manage extends Component {
  constructor(props) {
    super(props);
    this.state = { invoiceType: {} };
  }

  componentWillMount() {
    this.userUuid = LocalDb.get('userUuid');
  }

  componentDidMount() {
    this.getInvoiceType();
  }

  handleChange = (pagination, filters, sorter) => {
    this.props.onChange(pagination, filters, sorter);
  };

  invoiceDelete = uuid => {
    queryInvoiceDelete({
      uuid,
    }).then(res => {
      if (res.statusCode === 200) {
        message.success(res.message);
        this.props.loadData();
      } else {
        message.error(res.message);
      }
    });
  };

  getInvoiceType = () => {
    queryInvoiceType().then(res => {
      if (res.statusCode === 200) {
        const invoiceType = {};
        res.data.forEach(item => {
          invoiceType[item.value] = item.key;
        });
        this.setState({
          invoiceType,
        });
      }
    });
  };

  columns = () => {
    const { invoiceType } = this.state;
    return [
      {
        title: '客户',
        dataIndex: 'custom',
        key: 'custom',
        width: 150,
        render: (text, record) => (
          <span>
            {record.custom}
            {record.projectName ? `(${record.projectName})` : ''}
          </span>
        ),
      },
      {
        title: '付款公司',
        dataIndex: 'company',
        key: 'company',
        width: 150,
      },
      {
        title: '开票类型',
        dataIndex: 'type',
        key: 'type',
        render: text => <span>{invoiceType[text]}</span>,
      },
      {
        title: '开票金额',
        dataIndex: 'price',
        key: 'price',
        render: text => <span>{util.numberFormat(text)}</span>,
      },
      {
        title: '申请时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: (text, record) => {
          return <span>{moment.unix(text / 1000).format('YYYY-MM-DD')}</span>;
        },
      },
      {
        title: '当前环节',
        dataIndex: 'name',
        key: 'name',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          return <span>{currentActivity.name || ''}</span>;
        },
      },
      {
        title: '当前处理人',
        dataIndex: 'processorName',
        key: 'processorName',
        render: (text, record) => {
          const instance = record.instance || {};
          const currentActivity = instance.currentActivity || {};
          return <span>{currentActivity.processorName || ''}</span>;
        },
      },
      {
        title: '完成时间',
        dataIndex: 'finishTime',
        key: 'finishTime',
        render: (text, record) => {
          return <span>{text ? moment.unix(text / 1000).format('YYYY-MM-DD') : ''}</span>;
        },
      },
      {
        title: '状态',
        dataIndex: 'long',
        render: (text, record) => {
          const instance = record.instance || {};
          let element;
          if (instance.status === 1) {
            element = <span style={{ color: 'red' }}>已完成</span>;
          } else {
            element = record.instance ? <span>处理中</span> : <span>待编辑</span>;
          }
          return element;
        },
      },
      {
        title: '操作',
        dataIndex: 'done',
        render: (text, record) => {
          return <Link to={`/incubator/invoice_manage/open/${record.uuid}`}>查看</Link>;
        },
      },
    ];
  };

  render() {
    const {
      dataSource: { list, pagination },
      loading,
    } = this.props;
    return (
      <Table
        rowKey="uuid"
        loading={loading}
        dataSource={list}
        pagination={pagination}
        columns={this.columns()}
        onChange={this.handleChange}
      />
    );
  }
}

export default Form.create({ wrappedComponentRef: true })(Manage);



// WEBPACK FOOTER //
// ./src/components/incubator/invoice/TableBack.js